import axios from "axios";
import { config } from "../config";
import { logger } from "../lib/logger";
import { ErrorCodes } from "../lib/errorCodes";
import { SnapshotUtils } from "../types/newTypes/Snapshot";
import { ILightSnapshot, LightSnapshotUtils } from "../types/leanTypes/lightSnapshot";
import { fetchRawSnapshot } from "../mini_server";
import {
  fetchAccountAllowances,
  fetchAccountBalances,
  fetchAccountByName,
  fetchLightUserSnapshot,
  fetchSafesByUserAddress,
  fetchUserHelpersDataByUserAddress,
  newFetcNParsehHelpersSnapshots,
} from "./profile";
import { fetchEstimatedFee, fetcTransactions, fetchAssets } from "./wallet";
import { fetchEmailHelper, verifyVerificationCode, sendVerificationCode } from "./email";

const fetchBaseSnapshot = async ({ address }: { address: string }): Promise<ILightSnapshot> => {
  try {
    const response = await fetchRawSnapshot({ address });
    if (!response) {
      throw new Error("Something went wrong while trying to fetch basic snapshot");
    }

    const lightSnapshot: ILightSnapshot = LightSnapshotUtils.fromMap(response);

    return lightSnapshot;
  } catch (error) {
    logger.error("api", ErrorCodes.API_001, "Error fetching base snapshot", error as Error);
    throw new Error("Error fetching basic snapshot: " + error);
  }
};

const fetchSnapshot = async ({ address }: { address: string }) => {
  try {
    const response = await axios.get(
      `${config.nodeUrl}/snapshot/safe?publickey=${address}&env=${
        config.nodeLab === "9093" ? "main" : "test"
      }`
    );
    if (response.status !== 200) {
      throw new Error("Somthing went wrong while trying to fetch snapshhot");
    }
    const snapshot = SnapshotUtils.fromMap(response.data);

    // return response.data as ISnapshot;
    return snapshot;
  } catch (error) {
    throw new Error(error);
  }
};
const newFetchSnapshot = async ({ address }: { address: string }) => {
  try {
    const response = await axios.get(
      `${config.nodeUrl}/snapshot/safe?publickey=${address}&env=${
        config.nodeLab === "9093" ? "main" : "test"
      }`
    );
    if (response.status !== 200) {
      throw new Error("Somthing went wrong while trying to fetch snapshhot");
    }
    // const snapshot = SnapshotUtils.fromMap(response.data);

    // // return response.data as ISnapshot;
    // return snapshot;
    return response.data;
  } catch (error) {
    logger.error("api", ErrorCodes.API_001, "Error fetching snapshot", error as Error);
    return [];
  }
};

const createNewAccount = async ({
  displayName,
  userName,
  address,
  nameSource,
}: {
  displayName: string;
  userName: string;
  address: string;
  nameSource: string;
}) => {
  try {
    //https://reverse-proxy.omnistar.io/mainnet/proxy/users/accounts/createAccount

    const url = `${config.proxyUrl}/users/accounts/createAccount/`;
    const body = {
      displayName: displayName,
      name: userName,
      address: address,
      name_source: nameSource,
      env: config.nodeLab === "9093" ? "mainnet" : "testnet",
    };

    const headers = {
      "Content-Type": "application/json",
      "api-key": import.meta.env.VITE_PROXY_API_KEY,
      env: "main",
    };

    const response = await axios.post(url, body, { headers });
    if (response.status !== 200) {
      logger.error("api", ErrorCodes.API_002, "createNewAccount non-2xx response", undefined, {
        status: response.status,
      });
      //   throw new Error("Somthing went wrong while trying to create new account");
      return null;
    }
    return response.data;
  } catch (error) {
    logger.error("api", ErrorCodes.API_001, "Error creating new account", error as Error);
    // throw new Error(error);
    return null;
  }
};

export {
  fetchLightUserSnapshot,
  newFetcNParsehHelpersSnapshots,
  fetchUserHelpersDataByUserAddress,
  fetchBaseSnapshot,
  fetchSnapshot,
  newFetchSnapshot,
  fetchSafesByUserAddress,
  fetchEstimatedFee,
  fetcTransactions,
  fetchAssets,
  fetchAccountBalances,
  fetchAccountAllowances,
  fetchAccountByName,
  createNewAccount,
  fetchEmailHelper,
  sendVerificationCode,
  verifyVerificationCode,
};
